import "../fieldForce.css";
import back from "../../../assets/back.svg";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import CreateBtn from "../../../components/buttons/createBtn";
import InputField from "../../../components/form/inputField/inputField";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import {
  createFieldForceDesignation,
  reportingDesignationList,
} from "../../../redux/actions/fieldForceAction";
import InputFieldAmount from "../../../components/form/inputField/inputFieldAmount";
import SelectField from "../../../components/form/selectField/selectField";
import CreatedPopUp from "../../../components/popups/CreatedPopUp";
import Switch from "react-switch";
import InputCapitalField from "../../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceDesignationCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [created, setCreated] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const initialValues = {
    name: "",
    order_approval_from: "",
    order_approval_upto: "",
    approval_level: "",
    approval_authority: false,
    customer_verification: false,
  };

  const clearFunc = (setFieldValue) => {
    setFieldValue("name", "");
    setFieldValue("order_approval_from", "");
    setFieldValue("order_approval_upto", "");
    setFieldValue("approval_level", "");
    setFieldValue("approval_authority", false);
    setFieldValue("customer_verification", false);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    approval_authority: Yup.boolean().required("Required"),
    order_approval_from: Yup.number().when(["approval_authority"], {
      is: (approvalAuthority) => {
        return approvalAuthority === true;
      },
      then: Yup.number()
        .integer("Invalid")
        .typeError("invalid value")
        .required("Required"),
    }),
    order_approval_upto: Yup.number().when(["approval_authority"], {
      is: (approvalAuthority) => {
        return approvalAuthority === true;
      },
      then: Yup.number()
        .integer("Invalid")
        .typeError("invalid value")
        .required("Required"),
    }),
    approval_level: Yup.string().required("Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    dispatch(createFieldForceDesignation(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setCreated(true);
    const timeOutFnc = () => {
      setCreated(false);
      navigate("/field-force/designation");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const onError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setErrorMsg(str_modify);
    setError(true);

    const timeOutFnc = () => {
      setError(false);
    };
    setTimeout(timeOutFnc, 2000);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/designation",
      breadcrumb: " / field force / designation",
    },
    { path: "/field-force/designation/create", breadcrumb: " / create" },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      type="button"
                      background="#E7E5FF"
                      width="100px"
                      onClick={() => clearFunc(setFieldValue)}
                    >
                      CLEAR
                    </AdminButton>
                    <AdminButton
                      background="#7065e4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>

                <div className="field-force-Designation-form-width px-4">
                  <div className="my-4">
                    <InputCapitalField
                      setFieldValue={setFieldValue}
                      id={"name"}
                      label={"Designation Name"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter designation name"}
                      name={"name"}
                      value={values?.name}
                    />
                  </div>
                  <div className="my-2">
                    <label className="color_262c3d fw_400 fs_14">Levels</label>
                    <Field>
                      {({ form, Field }) => (
                        <Select
                          options={options}
                          styles={customStyles}
                          {...Field}
                          placeholder={"Select level"}
                          id="approval_level"
                          value={options.filter(
                            (c) => c.value == values?.approval_level
                          )}
                          onChange={(selectedOption) => {
                            form.setFieldValue(
                              "approval_level",
                              selectedOption.value
                            );
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="approval_level" />
                  </div>

                  <>
                    <div className="d-flex my-4 align-items-center color_262c3d fw_400 fs_14">
                      <label>Customer Verification</label>
                      <Switch
                        checked={values?.customer_verification}
                        onChange={() => {
                          if (!values.customer_verification) {
                            setFieldValue("customer_verification", true);
                          } else {
                            setFieldValue("customer_verification", false);
                          }
                        }}
                        className="mx-3"
                        onColor="#d3d6eb"
                        offColor="#d3d6eb"
                        onHandleColor="#7065E4"
                        offHandleColor="#747F9E"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={40}
                      />
                    </div>

                    <div className="d-flex my-2 align-items-center color_262c3d fw_400 fs_14">
                      <label>Approval Authority</label>
                      <Switch
                        checked={values?.approval_authority}
                        onChange={() => {
                          if (!values.approval_authority) {
                            setFieldValue("approval_authority", true);
                          } else {
                            setFieldValue("approval_authority", false);
                          }
                        }}
                        className="mx-3"
                        onColor="#d3d6eb"
                        offColor="#d3d6eb"
                        onHandleColor="#7065E4"
                        offHandleColor="#747F9E"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={40}
                      />
                    </div>

                    {values.approval_authority && (
                      <>
                        <div>
                          <InputFieldAmount
                            labelColor={"color_262c3d"}
                            label={"Order Approval Limit From"}
                            type="number"
                            className="amount_input py-1 ms-1"
                            id="order_approval_from"
                            name="order_approval_from"
                            placeholder="Enter amount"
                          />
                          <InputFieldAmount
                            labelColor={"color_262c3d"}
                            label={"Order Approval Limit Upto"}
                            type="number"
                            className="amount_input py-1 ms-1"
                            id="order_approval_upto"
                            name="order_approval_upto"
                            placeholder="Enter amount"
                          />
                        </div>
                      </>
                    )}
                  </>
                </div>
              </Form>
            )}
          </Formik>
          <CreatedPopUp
            show={created}
            handelClose={() => setCreated(false)}
            title={"Designation Created Successfully"}
          />
          <ErrorPopup
            show={error}
            handelClose={() => setError(false)}
            title={errorMsg}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldForceDesignationCreate;

const options = [
  { value: "L1", label: "Level 1" },
  { value: "L2", label: "Level 2" },
  { value: "L3", label: "Level 3" },
  { value: "L4", label: "Level 4" },
  { value: "L5", label: "Level 5" },
  { value: "L6", label: "Level 6" },
  { value: "L7", label: "Level 7" },
  { value: "L8", label: "Level 8" },
  { value: "L9", label: "Level 9" },
  { value: "L10", label: "Level 10" },
  { value: "L11", label: "Level 11" },
  { value: "L12", label: "Level 12" },
  { value: "L13", label: "Level 13" },
  { value: "L14", label: "Level 14" },
  { value: "L15", label: "Level 15" },
  { value: "admin", label: "Admin" },
];
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
